import React, { useEffect, useState } from "react";
import Form from "olive-react-myoneui/lib/Form";
import Dropdown from "olive-react-myoneui/lib/Dropdown";
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import "react-phone-input-2/lib/style.css";
import Button from "olive-react-myoneui/lib/Button";
import { clockIcon, organizationIcon } from "../../../constants/icons";
import {
  getCountryCodes,
  getOrganizations,
  getTimezone,
  updateLearner,
} from "../../../../api/afterLogin/learners";
import { useDispatch, useSelector } from "react-redux";
import { Toast, ToastInfo } from "olive-react-myoneui";
import EmailUpdateModal from "../EmailUpdateModal";
import { FormLoader } from "../../Loader";
import { setConfigData } from "../../../../reducers/configSlice";
import MobileUpdateModal from "../MobileUpdateModal";

const ProfileDetails = ({ setHasError }) => {
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const configData = useSelector((state) => state.config);
  const learnerData = configData.session;

  const address_mandatory = configData?.address_mandatory === "1";
  const phno_mandatory = configData?.phno_mandatory === "1";
  const org_mandatory = configData?.org_mandatory === "1";
  const [formData, setFormData] = useState({
    fullname: "",
    email: "",
    phone_country_code: "",
    phone_calling_code: "",
    phone: "",
    address1: "",
    address2: "",
    district: "",
    province: "",
    pincode: "",
    country: "",
    timezone: "",
    organization: "",
  });

  const [validated, setValidated] = useState(false);
  const [selectedPhoneCountryCode, setSelectedPhoneCountryCode] = useState("");
  const [selectedPhoneCountryCallingCode, setSelectedPhoneCountryCallingCode] =
    useState("");
  const [allTimezones, setAllTimeZones] = useState({});
  const [allOrganizations, setAllOrganizations] = useState([]);
  const [allCountryCodes, setAllCountryCodes] = useState([]);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isPhoneValid, setIsPhoneValid] = useState(true);
  const [selectedOrg, setSelectedOrg] = useState(0);
  const [selectedTimeZone, setSelectedTimeZone] = useState("");
  const [showSuccessProfileUpdate, setShowSuccessProfileUpdate] =
    useState(false);
  const [showErrorProfileUpdate, setShowErrorProfileUpdate] = useState(false);
  const [errorProfileMessage, setErrorProfileMessage] = useState({});
  const [inValid, setInValid] = useState({
    fullname: false,
    email: false,
    address1: false,
    address2: false,
    district: false,
    province: false,
    pincode: false,
  });
  const [showEmailUpdateModal, setShowEmailUpdateModal] = useState(false);
  const [emailUpdateMessage, setEmailUpdateMessage] = useState('');
  const [searchCountry, setSearchCountry] = useState("");
  const [showCountryDropdown, setShowCountryDropdown] = useState(false);
  const [timezoneSearch, setTimezoneSearch] = useState("");
  const [showTimezoneDropdown, setShowTimezoneDropdown] = useState(false);
  const [searchOrganization, setSearchOrganization] = useState("");
  const [showOrganizationDropdown, setShowOrganizationDropdown] = useState(false);
  const [showMobileUpdateModal, setShowMobileUpdateModal] = useState(false);
  const [showMobileUpdateMessage, setShowMobileUpdateMessage] = useState("");

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    setPhoneNumber(value);
    setIsPhoneValid(value.trim() !== "");
    setFormData({ ...formData, phone: value });
  };

  const handlePhoneCountryChange = (option) => {
    setFormData({
      ...formData,
      phone_country_code: option.country_code,
      country: option.country_name,
      phone_calling_code: "+"+option.calling_code
    });
    setSelectedPhoneCountryCode(option.country_code);
    setSelectedPhoneCountryCallingCode("+"+option.calling_code);
  };

  const handleOrgChange = (selectedOrg) => {
    setFormData({ ...formData, organization: selectedOrg.id });
    setSelectedOrg(selectedOrg.ol_name);
  };

  const handleTimeZoneChange = (key) => {
    setFormData({ ...formData, timezone: key });
    setSelectedTimeZone(allTimezones[key]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newInvalid = {
      fullname: formData.fullname.trim() === "",
      email: formData.email.trim() === "",
      address1: address_mandatory ? formData.address1.trim() === "" : false,
      address2: false,
      district: false,
      province: false,
      pincode: address_mandatory ? formData.pincode.trim() === "" : false,
      phone: phno_mandatory ? phoneNumber.trim() === "" : false,
      organization: org_mandatory ? !selectedOrg?.trim?.() : false,
    };
    
    setIsPhoneValid(!newInvalid.phone);
    setInValid(newInvalid);
    if (Object.values(newInvalid).some(val => val)) {
      return;
    }

    try {
      const postParams = {
        user_name: formData.fullname,
        email_id: formData.email,
        phone_country_code: formData.phone_calling_code,
        user_country: formData.country,
        us_country: formData.phone_country_code,
        us_house_name: formData.address1,
        us_location: formData.address2,
        us_district: formData.district,
        us_state: formData.province,
        us_pincode: formData.pincode,
        phone_number: formData.phone,
        us_timezone: formData.timezone,
        us_orgainization: formData.organization,
      };

      const response = await updateLearner(configData.access_token, postParams);
      if (response.status == 200) {
        const us_address = JSON.stringify({
          us_country: formData.country,
          us_pincode: formData.pincode,
          us_state: formData.province,
          us_district: formData.district,
          us_location: formData.address2,
          us_house_name: formData.address1,
        });

        const updatedUserData = {
          ...learnerData, // Keep existing data unchanged
          us_address: us_address,
          us_name: formData.fullname,
          us_email: formData.email,
          us_phone: formData.phone,
          us_country_code: formData.phone_calling_code
        };

        /* ON PHONE CHANGED THEN USER SEND TO LOGOUT */
        const oldPhone = learnerData.us_phone;
        if (oldPhone != formData.phone) {
          setShowMobileUpdateMessage(`Contact number updated to ${formData.phone}, so user need to re-login`);
          setShowMobileUpdateModal(true);
          localStorage.setItem("email_contact_updated", Date.now() + 2 * 60 * 1000);
          return;
        }

        dispatch(setConfigData({ session: updatedUserData }));

        //Success Toast
        setShowSuccessProfileUpdate(true);
      } else {
        //Error Toast
        setShowErrorProfileUpdate(true);
        if (response.status == 3) {
          setErrorProfileMessage({message:response.message});
          setEmailUpdateMessage(response.message);
          setShowEmailUpdateModal(true);
          localStorage.setItem("email_contact_updated", Date.now() + 2 * 60 * 1000);
          return;
        }
        setErrorProfileMessage(response.message);
      }
    } catch (err) {
      setShowErrorProfileUpdate(true);
      setErrorProfileMessage(err.response.data.message);
      console.log("update learner error: ", err);
    }
  };

  const loadInitialLearnerDetails = async () => {
    try {
    const timezones = await getTimezone(configData.access_token);
    const organizations = await getOrganizations(configData.access_token);
    const countryCodes = await getCountryCodes(configData.access_token);
    const learnerDetails = configData.session;
    const selectedOrganization = organizations.find(
      (org) => org.id === learnerDetails.us_organization_id
    );
    const addressObject = learnerDetails.us_address && ((learnerDetails.us_address !== '' && learnerDetails.us_address != 'null') || learnerDetails.us_address != null)
        ? JSON.parse(learnerDetails.us_address)
        : {};

    let countryDetails = null;
    let countryCode = addressObject?.us_country || learnerDetails?.us_country || '';
    if (countryCode) {
      countryDetails = countryCodes.find(
          (country) =>
          country.country_code === countryCode || country.country_name === countryCode
      );
    } else if (learnerDetails?.us_country_code) {
      const normalizedCallingCode = String(learnerDetails.us_country_code).trim().replace(/^\+/, "");
      countryDetails = countryCodes.find((country) =>
          String(country.calling_code).trim().replace(/^\+/, "") === normalizedCallingCode
      );
    }    
    if (countryDetails) {
      countryCode = countryDetails.country_code;
    }
    const countryName = countryDetails ? countryDetails.country_name : countryCode;

    setFormData({
      fullname: learnerDetails.us_name,
      email: learnerDetails.us_email,
      address1: addressObject?.us_house_name ?? "",
      address2: addressObject?.us_location ?? "",
      district: addressObject?.us_district ?? "",
      province: addressObject?.us_state ?? "",
      pincode: addressObject?.us_pincode ?? "",
      country: countryName,
      phone_country_code: countryCode,
      phone_calling_code: learnerDetails?.us_country_code ?? "",
      timezone: learnerDetails?.us_timezone ?? "",
      phone: learnerDetails?.us_phone ?? "",
      organization: selectedOrganization?.id ?? 0,
    });

    setAllTimeZones(timezones);
    setAllOrganizations(organizations);
    setAllCountryCodes(countryCodes);
    setSelectedPhoneCountryCode(countryCode);
    setSelectedPhoneCountryCallingCode(learnerDetails?.us_country_code ?? "");
    setPhoneNumber(learnerDetails?.us_phone ?? "");
    setSelectedTimeZone(
      learnerDetails?.us_timezone ? timezones[learnerDetails.us_timezone] : ""
    );
    setSelectedOrg(
      learnerDetails.us_organization_id ? selectedOrganization?.ol_name : ""
    );
  } catch (error){
    setHasError(true);
    console.error(error);
  } finally {
    setIsLoading(false);
  }
  };

  useEffect(() => {
    loadInitialLearnerDetails();
  }, []);

  return (
    <>
      {isLoading ? (
        <FormLoader items={12} />
      ) : (
      <Form
        className="col-xl-12"
        autoComplete="off"
        noValidate
        method="post"
        onSubmit={handleSubmit}
      >
        <Row>
          <div style={{ display: showSuccessProfileUpdate ? "block" : "none" }}>
            <Toast variant="primary" className="mb-2 mt-2">
              <Toast.Body>
                <ToastInfo toastDescription="Profile has been updated successfully." />
                <div className="action-wrapper">
                  <Button
                    variant="primary"
                    type="button"
                    size="sm"
                    className="btn-round bg-primary-fade"
                    aria-label="Close"
                    onClick={() => setShowSuccessProfileUpdate(false)}
                  >
                    Close
                  </Button>
                </div>
              </Toast.Body>
            </Toast>
          </div>

          <div style={{ display: showErrorProfileUpdate ? "block" : "none" }}>
            <Toast variant="error" className="mb-2 mt-2">
              <Toast.Body>
                <div className="flex flex-column">
                  {Object.values(errorProfileMessage).map((message) => (
                    <ToastInfo toastDescription={message} />
                  ))}
                </div>
                <div className="action-wrapper">
                  <Button
                    variant="error"
                    type="button"
                    size="sm"
                    className="btn-round bg-orange-fade text-white"
                    aria-label="Close"
                    onClick={() => setShowErrorProfileUpdate(false)}
                  >
                    Close
                  </Button>
                </div>
              </Toast.Body>
            </Toast>
          </div>

          <Col xl="6">
            <Form.Group className="mb-4" controlId="fullname" label="Full Name">
              <Form.Label>Full name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Full Name"
                name="fullname"
                defaultValue={formData.fullname}
                onChange={(e) => {
                  setFormData({ ...formData, fullname: e.target.value });
                }}
                onBlur={(e) => {
                  setFormData({ ...formData, fullname: e.target.value });
                }}
                className={`myk__stu-ph-number ${
                  inValid.fullname ? "is-invalid" : ""
                }`}
                required
              />
              {inValid.fullname && (
                <Form.Control.Feedback type="invalid" className="d-block">
                  Please provide your Full Name.
                </Form.Control.Feedback>
              )}
            </Form.Group>
          </Col>
          <Col xl="6">
            <Form.Group className="mb-4" controlId="email" label="Email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                placeholder="name@email.com"
                defaultValue={formData.email}
                onChange={(e) => {
                  setFormData({ ...formData, email: e.target.value })
                }}
                onBlur={(e) => {
                  setFormData({ ...formData, email: e.target.value })
                }}
                className={`myk__stu-ph-number ${
                  inValid.email ? "is-invalid" : ""
                }`}
                required
              />
              {inValid.email && (
              <Form.Control.Feedback type="invalid">
                Please provide your Email address.
              </Form.Control.Feedback>)}
            </Form.Group>
          </Col>
          <Col xl="6">
            <Form.Group className="mb-4" controlId="phone" label="Phone">
              <Form.Label>Phone Number {phno_mandatory && <span className="text-danger"> *</span>}</Form.Label>
              <div
                className={`myk__stu-number-group form-control ${
                  !isPhoneValid ? "is-invalid" : ""
                }`}
              >
                <Dropdown
                    className="dropdown-select text-start myk__stu-ph-country"
                    align="start"
                    show={showCountryDropdown}
                    onToggle={(isOpen) => {
                        setShowCountryDropdown(isOpen);
                        if (!isOpen) setSearchCountry("");
                    }}
                >
                  <Dropdown.Toggle
                      as="div"
                      role="button"
                      tabIndex={0}
                      className="border-0"
                  >
                      <Form.Control
                          type="text"
                          placeholder="Country"
                          value={selectedPhoneCountryCode}
                          name="us_country"
                          id="phcountry"
                          readOnly
                          required
                          onClick={() => setShowCountryDropdown(true)}
                      />
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="dropdown-menu p-2">
                      <div className="search-box">
                          <Form.Control
                              type="text"
                              placeholder="Search country..."
                              value={searchCountry}
                              onChange={(e) => {
                                  setSearchCountry(e.target.value);
                                  setShowCountryDropdown(true);
                              }}
                              autoFocus
                              className="myk__stu-ddmenu-search w-100 mb-2"
                          />
                      </div>
                      {allCountryCodes
                          .filter(option => 
                              option.country_name.toLowerCase().includes(searchCountry.toLowerCase()) ||
                              option.country_code.toLowerCase().includes(searchCountry.toLowerCase())
                          )
                          .map((option) => (
                              <Dropdown.Item
                                  key={option.country_code}
                                  onClick={() => {
                                      handlePhoneCountryChange(option);
                                      setShowCountryDropdown(false);
                                  }}
                                  className="select-item"
                              >
                                  ({option.country_code}) {option.country_name}
                              </Dropdown.Item>
                          ))}
                  </Dropdown.Menu>
                </Dropdown>
                <Form.Control
                  id="phcode"
                  type="text"
                  name="phcode"
                  placeholder="Code"
                  value={selectedPhoneCountryCallingCode}
                  className="myk__stu-ph-code"
                  readOnly
                />
                <Form.Control
                  type="text"
                  name="phone"
                  id="phone"
                  placeholder="Number"
                  value={phoneNumber}
                  onChange={handlePhoneChange}
                  className={`myk__stu-ph-number ${
                    !isPhoneValid ? "is-invalid" : ""
                  }`}
                  required
                />
              </div>
              {!isPhoneValid && (
                <Form.Control.Feedback type="invalid" className="d-block">
                  Please provide your Phone Number.
                </Form.Control.Feedback>
              )}
            </Form.Group>
          </Col>
          <Col xl="6">
            <Form.Group
              className="mb-4 w-100"
              controlId="country"
              label="Country"
            >
              <Form.Label>Country</Form.Label>
              <Form.Control
                type="text"
                placeholder="Country"
                value={formData.country}
                required
                readOnly
                name="country"
              />
              <Form.Control.Feedback type="invalid">
                Please provide your Country.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col xl="6">
            <Form.Group
              className="mb-4 w-100"
              controlId="address1"
              label="Address 1"
            >
              <Form.Label>Address 1 {address_mandatory && <span className="text-danger"> *</span>}</Form.Label>
              <Form.Control
                type="text"
                placeholder="Address 1"
                value={formData.address1}
                onChange={(e) => {
                  setFormData({ ...formData, address1: e.target.value });
                }}
                onBlur={(e) => {
                  setFormData({ ...formData, address1: e.target.value });
                }}
                className={`myk__stu-ph-number ${
                  inValid.address1 ? "is-invalid" : ""
                }`}
                required
                name="address1"
              />
              {inValid.address1 && (
              <Form.Control.Feedback type="invalid">
                Please provide your Address 1.
              </Form.Control.Feedback>)}
            </Form.Group>
          </Col>
          <Col xl="6">
            <Form.Group
              className="mb-4 w-100"
              controlId="address2"
              label="Address 2"
            >
              <Form.Label>Address 2</Form.Label>
              <Form.Control
                type="text"
                placeholder="Address 2"
                defaultValue={formData.address2}
                onChange={(e) => {
                  setFormData({ ...formData, address2: e.target.value })
                }}
                onBlur={(e) => {
                  setFormData({ ...formData, address2: e.target.value });
                }}
                className={`myk__stu-ph-number ${
                  inValid.address2 ? "is-invalid" : ""
                }`}
                required
                name="address2"
              />
              {inValid.address2 && (
              <Form.Control.Feedback type="invalid">
                Please provide your Address 2.
              </Form.Control.Feedback>)}
            </Form.Group>
          </Col>
          <Col xl="6">
            <Form.Group
              className="mb-4 w-100"
              controlId="district"
              label="City"
            >
              <Form.Label>City / Town</Form.Label>
              <Form.Control
                type="text"
                placeholder="City / Town"
                defaultValue={formData.district}
                onChange={(e) => {
                  setFormData({ ...formData, district: e.target.value })
                }}
                onBlur={(e) => {
                  setFormData({ ...formData, district: e.target.value })
                }}
                required
                className={`myk__stu-ph-number ${
                  inValid.district ? "is-invalid" : ""
                }`}
                name="district"
              />
              {inValid.district && (
              <Form.Control.Feedback type="invalid">
                Please provide your City / Town.
              </Form.Control.Feedback>)}
            </Form.Group>
          </Col>
          <Col xl="6">
            <Form.Group
              className="mb-4 w-100"
              controlId="province"
              label="Province / County / State"
            >
              <Form.Label>Province / County / State</Form.Label>
              <Form.Control
                type="text"
                placeholder="Province / County / State"
                defaultValue={formData.province}
                onChange={(e) => {
                  setFormData({ ...formData, province: e.target.value })
                }}
                onBlur={(e) => {
                  setFormData({ ...formData, province: e.target.value })
                }}
                className={`myk__stu-ph-number ${
                  inValid.province ? "is-invalid" : ""
                }`}
                required
                name="province"
              />
              {inValid.province && (
              <Form.Control.Feedback type="invalid">
                Please provide your Province / County / State.
              </Form.Control.Feedback>)}
            </Form.Group>
          </Col>
          <Col xl="6">
            <Form.Group
              className="mb-4 w-100"
              controlId="pincode"
              label="Postcode / Zipcode"
            >
              <Form.Label>Postcode / Zipcode {address_mandatory && <span className="text-danger"> *</span>}</Form.Label>
              <Form.Control
                type="text"
                placeholder="Postcode / Zipcode"
                defaultValue={formData.pincode}
                onChange={(e) => {
                  setFormData({ ...formData, pincode: e.target.value })
                }}
                onBlur={(e) => {
                  setFormData({ ...formData, pincode: e.target.value })
                }}
                className={`myk__stu-ph-number ${
                  inValid.pincode ? "is-invalid" : ""
                }`}
                required
                name="pincode"
              />
              {inValid.pincode && (
              <Form.Control.Feedback type="invalid">
                Please provide your Postcode / Zipcode.
              </Form.Control.Feedback>)}
            </Form.Group>
          </Col>
          <Col xl="6">
            <Form.Group className="mb-4" controlId="timezone" label="Timezone">
              <div className="myk_stu-dropdown-group">
                <Form.Label>Timezone</Form.Label>
                <span className="myk__stu-dropdown-icon">{clockIcon}</span>
                <Dropdown 
                  className="dropdown-select text-start" 
                  align="start"
                  show={showTimezoneDropdown}
                  onToggle={(isOpen) => {
                      setShowTimezoneDropdown(isOpen);
                      if (!isOpen) setTimezoneSearch('');
                  }}
                  required
              >
                  <Dropdown.Toggle as="div" role="button" tabIndex={0} className="border-0">
                      <Form.Control
                          type="text"
                          placeholder="Time Zone"
                          name="timezone"
                          value={showTimezoneDropdown ? selectedTimeZone : (selectedTimeZone || '')}
                          readOnly
                          onClick={() => setShowTimezoneDropdown(true)}
                      />
                  </Dropdown.Toggle>
                  
                  <Dropdown.Menu className="dropdown-menu p-2">
                      <div className="search-box">
                          <Form.Control
                              type="text"
                              placeholder="Search Time Zone"
                              name="timezone-search"
                              value={timezoneSearch}
                              onChange={(e) => {
                                  setTimezoneSearch(e.target.value);
                                  setShowTimezoneDropdown(true);
                              }}
                              autoFocus
                              className="mb-2 w-100"
                          />
                      </div>
                      {Object.entries(allTimezones)
                          .filter(([key, value]) => 
                              value.toLowerCase().includes(timezoneSearch.toLowerCase())
                          )
                          .map(([key, value]) => (
                              <Dropdown.Item
                                  key={key}
                                  onClick={() => {
                                      handleTimeZoneChange(key);
                                      setShowTimezoneDropdown(false);
                                  }}
                                  className="select-item"
                              >
                                  {value}
                              </Dropdown.Item>
                          ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Form.Group>
          </Col>
          <Col xl="6">
            <Form.Group
              className="mb-4"
              controlId="organization"
              label="Organization"
            >
              <div className="myk_stu-dropdown-group">
                <Form.Label>Organization {org_mandatory && <span className="text-danger"> *</span>}</Form.Label>
                <span className="myk__stu-dropdown-icon">
                  {organizationIcon}
                </span>
                <Dropdown
                    className="dropdown-select text-start myk__stu-ph-country"
                    align="start"
                    show={showOrganizationDropdown}
                    onToggle={(isOpen) => {
                        setShowOrganizationDropdown(isOpen);
                        if (!isOpen) setSearchOrganization("");
                    }}
                >
                  <Dropdown.Toggle
                      as="div"
                      role="button"
                      tabIndex={0}
                      className="border-0"
                  >
                      <Form.Control
                          type="text"
                          placeholder="Organization"
                          value={showOrganizationDropdown ? selectedOrg : (selectedOrg || '')}
                          name="organization"
                          readOnly
                          required
                          onClick={() => setShowOrganizationDropdown(true)}
                          className={`myk__stu-ph-number ${
                            inValid.organization ? "is-invalid" : ""
                          }`}
                      />
                      {inValid.organization && (
                        <Form.Control.Feedback type="invalid" className="d-block">
                          Please provide your Organization.
                        </Form.Control.Feedback>
                      )}
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="dropdown-menu p-2">
                    
                      <div className="search-box">
                          <Form.Control
                              type="text"
                              placeholder="Search Organization..."
                              value={searchOrganization}
                              onChange={(e) => {
                                  setSearchOrganization(e.target.value);
                                  setShowOrganizationDropdown(true);

                              }}
                              autoFocus
                              className="myk__stu-ddmenu-search w-100 mb-2"
                          />
                      </div>
                      
                      {allOrganizations
                          .flatMap(group => group)
                          .filter(option => 
                              option.ol_name.toLowerCase().includes(searchOrganization.toLowerCase())
                          )
                          .map((option) => (
                              <Dropdown.Item
                                  key={option.id}
                                  onClick={() => {
                                      handleOrgChange(option)
                                      setShowOrganizationDropdown(false);
                                  }}
                                  className="select-item"
                              >
                                  {option.ol_name}
                              </Dropdown.Item>
                          ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Form.Group>
          </Col>
        </Row>
        <div className="action-btns text-end">
          <Button variant="default">Cancel</Button>
          <Button variant="primary" type="submit">
            Save changes
          </Button>
        </div>
      </Form>
      )}
      {showEmailUpdateModal && (
        <EmailUpdateModal title={'Email Updated'} message={emailUpdateMessage} />
      )}
      {showMobileUpdateModal && (
        <MobileUpdateModal title={'Contact Number Updated'} message={showMobileUpdateMessage} />
      )}
    </>
  );
};

export default ProfileDetails;
